/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = DueIn
 *
 * 1 = CheckedInToday
 *
 * 2 = WorkInProgress
 *
 * 3 = AwaitingCheckedOut
 *
 * 4 = AwaitingOnSite
 *
 * 5 = CompletedNotInvoiced
 *
 * 6 = Invoiced
 *
 * 7 = InvoicedNotCollected
 */
export enum WorkshopFilterType {
  DueIn = 0,
  CheckedInToday = 1,
  WorkInProgress = 2,
  AwaitingCheckedOut = 3,
  AwaitingOnSite = 4,
  CompletedNotInvoiced = 5,
  Invoiced = 6,
  InvoicedNotCollected = 7,
}
